/** Shared styling for Commerce+ — matches genre operator dashboard (dash-*) when theme is "dash". */

export function getCommerceTheme(theme = 'dark') {
  const dash = theme === 'dash';
  return {
    page: dash ? 'space-y-6 text-slate-800' : 'space-y-6',
    loading: dash ? 'text-slate-500 py-8 text-center' : 'text-zinc-400 py-8 text-center',
    card: dash
      ? 'bg-white border border-slate-200 rounded-xl p-6 space-y-4 shadow-sm'
      : 'bg-zinc-900/50 border border-zinc-800 rounded-xl p-6 space-y-4',
    title: dash ? 'text-lg font-bold text-slate-900' : 'text-lg font-bold',
    muted: dash ? 'text-sm text-slate-500' : 'text-sm text-zinc-400',
    label: dash ? 'text-sm text-slate-600 block mb-1' : 'text-sm text-zinc-400 block mb-1',
    labelBlock: dash ? 'text-sm text-slate-600 block mb-2' : 'text-sm text-zinc-400 block mb-2',
    input: dash
      ? 'w-full px-3 py-2 bg-white border border-slate-300 rounded-lg text-slate-900 focus:outline-none focus:ring-2 focus:ring-indigo-500/30'
      : 'w-full px-3 py-2 bg-zinc-800 border border-zinc-700 rounded-lg',
    inputInline: dash
      ? 'px-3 py-2 bg-white border border-slate-300 rounded-lg text-slate-900'
      : 'px-3 py-2 bg-zinc-800 border border-zinc-700 rounded-lg',
    inputMd: dash
      ? 'w-full max-w-md px-3 py-2 bg-white border border-slate-300 rounded-lg'
      : 'w-full max-w-md px-3 py-2 bg-zinc-800 border border-zinc-700 rounded-lg',
    infoBanner: dash
      ? 'rounded-lg border border-indigo-200 bg-indigo-50 p-3 text-sm text-indigo-800'
      : 'rounded-lg border border-violet-500/30 bg-violet-500/10 p-3 text-sm text-violet-200',
    warnBanner: dash
      ? 'text-sm text-amber-800 bg-amber-50 border border-amber-200 rounded-lg px-3 py-2'
      : 'text-sm text-amber-300 bg-amber-500/10 border border-amber-500/30 rounded-lg px-3 py-2',
    currencyChipOn: dash
      ? 'border-indigo-500 bg-indigo-50 text-indigo-700'
      : 'border-violet-500 bg-violet-500/20 text-violet-300',
    currencyChipOff: dash
      ? 'border-slate-300 text-slate-500 hover:border-slate-400'
      : 'border-zinc-700 text-zinc-500',
    tabActive: dash
      ? 'bg-indigo-50 text-indigo-700 border border-indigo-200 font-semibold'
      : 'bg-violet-500 text-white',
    tabInactive: dash
      ? 'bg-white text-slate-600 border border-slate-200 hover:bg-slate-50'
      : 'bg-zinc-800 text-zinc-400 hover:text-white',
    row: dash
      ? 'flex items-center justify-between gap-3 p-3 bg-slate-50 border border-slate-200 rounded-lg text-sm'
      : 'flex items-center justify-between gap-3 p-3 bg-zinc-800/50 rounded-lg text-sm',
    orderRow: dash
      ? 'flex items-center gap-3 p-2 bg-slate-50 border border-slate-200 rounded-lg text-sm cursor-pointer'
      : 'flex items-center gap-3 p-2 bg-zinc-800/40 rounded-lg text-sm cursor-pointer',
    routeRow: dash
      ? 'p-3 bg-slate-50 border border-slate-200 rounded-lg text-sm flex justify-between'
      : 'p-3 bg-zinc-800/40 rounded-lg text-sm flex justify-between',
    meta: dash ? 'text-xs text-slate-500' : 'text-xs text-zinc-500',
    metaInline: dash ? 'text-zinc-500 shrink-0 hidden sm:inline text-slate-500' : 'text-zinc-500 shrink-0 hidden sm:inline',
    empty: dash ? 'text-sm text-slate-500' : 'text-sm text-zinc-500',
    primaryBtn: dash ? 'bg-indigo-600 hover:bg-indigo-700 text-white' : 'bg-violet-500 hover:bg-violet-600',
    outlineBtn: dash ? 'border-slate-300 text-slate-700 hover:bg-slate-50' : 'border-zinc-700',
    addDriverBtn: dash ? 'bg-slate-700 hover:bg-slate-800 text-white' : 'bg-zinc-700 hover:bg-zinc-600',
    driverLinkBtn: dash ? 'border-slate-300 shrink-0' : 'border-zinc-600 shrink-0',
    successText: dash ? 'text-xs text-emerald-600 pb-2' : 'text-xs text-emerald-400 pb-2',
    warnText: dash ? 'text-xs text-amber-700 pb-2' : 'text-xs text-amber-300 pb-2',
    routeMeta: dash ? 'text-slate-500' : 'text-zinc-400',
    placesInput: dash
      ? 'bg-white border-slate-300 text-slate-900'
      : '',
  };
}
